import { useEffect } from 'react';

/**
 * Hides the floating Emergent platform badge (#emergent-badge).
 * The badge is injected by the platform with inline `!important` styles, so we
 * must override imperatively via JS. The static "Made with Emergent" mention
 * already lives in the Footer.jsx bottom bar, so the attribution is preserved.
 *
 * A MutationObserver also catches the badge if it's added after first paint.
 */
const hideBadge = (badge) => {
  if (!badge || badge.dataset.swgHidden === '1') return;
  badge.style.setProperty('display', 'none', 'important');
  badge.style.setProperty('visibility', 'hidden', 'important');
  badge.style.setProperty('pointer-events', 'none', 'important');
  badge.setAttribute('aria-hidden', 'true');
  badge.dataset.swgHidden = '1';
};

const useEmergentBadgeBlend = () => {
  useEffect(() => {
    const existing = document.getElementById('emergent-badge');
    if (existing) hideBadge(existing);

    const observer = new MutationObserver(() => {
      const badge = document.getElementById('emergent-badge');
      if (badge && badge.dataset.swgHidden !== '1') hideBadge(badge);
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
};

export default useEmergentBadgeBlend;
